import React from 'react';
import { Button, SizeFittingTable } from 'src/components/Antd';
import css from './css.module.less';
// import Search from '@/src/components/Antd/Search/Search';
// import { SearchOutlined } from '@ant-design/icons';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { EnumTablePosition } from 'src/types/common/common';
// import { get } from 'lodash';
// import ModalHoc from 'src/constrains/ModalHOC';
// import { getCollectionList } from '@/src/request/salesChannel/collection';
// import { useParams } from 'react-router-dom';
// import { generalSort } from 'src/tools/helper';
// import { mockData1 } from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection/Col';
import { Icon } from '@/src/tools/icon';
import { EyeOutlined } from '@ant-design/icons';
import TagGroup from 'src/components/TagGroup/TagGroup';
import ProductSelection from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
// const mockData = [
//   {
//     uuid: '0fda85b9-de61-4e4f-b3bf-d2e8cc5c2dcb',
//     createdBy: '1',
//     modifiedBy: '1',
//     createdDate: '2021-09-01 18:12:45',
//     modifiedDate: '2021-09-01 18:13:15',
//     valid: true,
//     deleted: false,
//     storeUuid: '1',
//     salesChannelUuid: '4215eee0-8b7e-4dc1-be39-6488df9b36f7',
//     salesChannelName: null,
//     currency: null,
//     hasError: false,
//     errorDetail: {},
//     otherLocaleErrors: null,
//     visible: false,
//     productType: 'Multiple',
//     content: null,
//     customisation: null,
//     productName: '测试1351 Alias 1',
//     image: null,
//     thumbnailUrl: null,
//     salesChannelProductReview: null,
//     listPrice: null,
//     available: null,
//     sku: null,
//     tags: [],
//     children: [
//       // {
//       //   uuid: '33f300aa-6122-4c52-90d7-6e792200259f',
//       //   createdBy: null,
//       //   modifiedBy: null,
//       //   createdDate: null,
//       //   modifiedDate: null,
//       //   valid: false,
//       //   deleted: false,
//       //   storeUuid: null,
//       //   salesChannelUuid: null,
//       //   salesChannelName: null,
//       //   currency: null,
//       //   hasError: false,
//       //   errorDetail: null,
//       //   otherLocaleErrors: null,
//       //   visible: true,
//       //   productType: 'Single',
//       //   content: null,
//       //   customisation: null,
//       //   productName: '测试1351',
//       //   image: null,
//       //   thumbnailUrl: null,
//       //   salesChannelProductReview: null,
//       //   listPrice: 11,
//       //   available: 555,
//       //   sku: 'sku测试1351',
//       //   tags: [],
//       //   children: null,
//       //   productUuid: '33f300aa-6122-4c52-90d7-6e792200259f',
//       //   child: true,
//       //   alias: false,
//       // },
//       {
//         uuid: '6b97d4dc-27dc-4fa9-a6cd-de5b305eafee',
//         createdBy: null,
//         modifiedBy: null,
//         createdDate: null,
//         modifiedDate: null,
//         valid: false,
//         deleted: false,
//         storeUuid: null,
//         salesChannelUuid: null,
//         salesChannelName: null,
//         currency: null,
//         hasError: false,
//         errorDetail: null,
//         otherLocaleErrors: null,
//         visible: true,
//         productType: 'Single',
//         content: null,
//         customisation: null,
//         productName: 'asdasdfasz',
//         image: null,
//         thumbnailUrl: null,
//         salesChannelProductReview: null,
//         listPrice: 10,
//         available: 10,
//         sku: 'sdasd',
//         tags: [],
//         children: null,
//         productUuid: '6b97d4dc-27dc-4fa9-a6cd-de5b305eafee',
//         child: true,
//         alias: false,
//       },
//     ],
//     productUuid: null,
//     child: false,
//     alias: false,
//   },
//   {
//     uuid: '2978ca6e-c64f-4f2e-bd51-6014624d53eb',
//     createdBy: '1',
//     modifiedBy: '1',
//     createdDate: '2021-08-06 17:27:16',
//     modifiedDate: '2021-08-06 17:27:16',
//     valid: true,
//     deleted: false,
//     storeUuid: '1',
//     salesChannelUuid: '4215eee0-8b7e-4dc1-be39-6488df9b36f7',
//     salesChannelName: null,
//     currency: null,
//     hasError: false,
//     errorDetail: {},
//     otherLocaleErrors: null,
//     visible: false,
//     productType: null,
//     content: null,
//     customisation: null,
//     productName: null,
//     image: null,
//     thumbnailUrl: null,
//     salesChannelProductReview: null,
//     listPrice: null,
//     available: null,
//     sku: null,
//     tags: null,
//     children: null,
//     productUuid: null,
//     child: false,
//     alias: true,
//   },
//   {
//     uuid: 'd915537c-9f71-4230-b8f6-2bb3f9dd381c',
//     createdBy: '1',
//     modifiedBy: '1',
//     createdDate: '2021-09-01 18:12:58',
//     modifiedDate: '2021-09-01 18:12:58',
//     valid: true,
//     deleted: false,
//     storeUuid: '1',
//     salesChannelUuid: '4215eee0-8b7e-4dc1-be39-6488df9b36f7',
//     salesChannelName: null,
//     currency: null,
//     hasError: false,
//     errorDetail: {},
//     otherLocaleErrors: null,
//     visible: false,
//     productType: null,
//     content: null,
//     customisation: null,
//     productName: null,
//     image: null,
//     thumbnailUrl: null,
//     salesChannelProductReview: null,
//     listPrice: null,
//     available: null,
//     sku: null,
//     tags: null,
//     children: null,
//     productUuid: null,
//     child: false,
//     alias: true,
//   },
//   {
//     uuid: 'ff306295-e177-4bf2-bf8c-52b577db2e7f',
//     createdBy: '1',
//     modifiedBy: '1',
//     createdDate: '2021-08-06 17:27:07',
//     modifiedDate: '2021-09-01 17:52:56',
//     valid: true,
//     deleted: false,
//     storeUuid: '1',
//     salesChannelUuid: '4215eee0-8b7e-4dc1-be39-6488df9b36f7',
//     salesChannelName: null,
//     currency: null,
//     hasError: false,
//     errorDetail: {},
//     otherLocaleErrors: null,
//     visible: false,
//     productType: 'Multiple',
//     content: null,
//     customisation: null,
//     productName: '122341223多少岁 Alias 1',
//     image: null,
//     thumbnailUrl: null,
//     salesChannelProductReview: null,
//     listPrice: null,
//     available: null,
//     sku: null,
//     tags: [],
//     children: [
//       {
//         uuid: '3ae2e08a-77d1-4a5d-906f-6f58fb7c9176',
//         createdBy: null,
//         modifiedBy: null,
//         createdDate: null,
//         modifiedDate: null,
//         valid: false,
//         deleted: false,
//         storeUuid: null,
//         salesChannelUuid: null,
//         salesChannelName: null,
//         currency: null,
//         hasError: false,
//         errorDetail: null,
//         otherLocaleErrors: null,
//         visible: true,
//         productType: 'Single',
//         content: null,
//         customisation: null,
//         productName: '122341223多少岁',
//         image: null,
//         thumbnailUrl: null,
//         salesChannelProductReview: null,
//         listPrice: 123,
//         available: null,
//         sku: '打 算 asd',
//         tags: [],
//         children: null,
//         productUuid: '3ae2e08a-77d1-4a5d-906f-6f58fb7c9176',
//         child: true,
//         alias: false,
//       },
//       {
//         uuid: '2dfc89a7-6a4d-4024-a430-2c57c010c190',
//         createdBy: null,
//         modifiedBy: null,
//         createdDate: null,
//         modifiedDate: null,
//         valid: false,
//         deleted: false,
//         storeUuid: null,
//         salesChannelUuid: null,
//         salesChannelName: null,
//         currency: null,
//         hasError: false,
//         errorDetail: null,
//         otherLocaleErrors: null,
//         visible: true,
//         productType: 'Single',
//         content: null,
//         customisation: null,
//         productName: 'Mario 万岁',
//         image: null,
//         thumbnailUrl:
//           'https://image-uat.unifyxp.com/images/Product/3b4f2134-88a6-484f-8565-ed274043102a.jpeg',
//         salesChannelProductReview: null,
//         listPrice: 65,
//         available: null,
//         sku: 'Mario-111',
//         tags: [],
//         children: null,
//         productUuid: '2dfc89a7-6a4d-4024-a430-2c57c010c190',
//         child: true,
//         alias: false,
//       },
//     ],
//     productUuid: null,
//     child: false,
//     alias: false,
//   },
// ];
const addParentUuid = (products) => {
  return products.map((i) => {
    const { children, uuid } = i;
    if (children) {
      const _children = children.map((child) => {
        return { parentUuid: uuid, ...child };
      });
      return { ...i, children: _children };
    }
    return i;
  });
};

// const removeParentUuid = (products) => {
//   products.map((i) => {
//     const { children } = i;
//     if (children) {
//       const _children = children.map((child) => {
//         delete child['parentUuid'];
//         return child;
//       });
//       return { ...i, children: _children };
//     }
//     return i;
//   });
// };

const ProductTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    value,
    onChange,
    id,
    tableId,
    salesChannelUuid,
    disabledProducts,
    disableEdit,
    currency,
  } = props;
  const [products, setProducts] = React.useState(value || []);
  const isNoData = (products || []).length === 0;
  const [visible, setVisible] = React.useState(false);
  const processProduct = React.useMemo(() => {
    return addParentUuid(products || []);
  }, [products]);
  React.useEffect(() => {
    if (value !== products) {
      setProducts(value || []);
    }
  }, [value]);

  const handleOnCancel = () => {
    setVisible(false);
  };

  const handleOnChange = (products) => {
    if (onChange) {
      onChange(products);
    }
    // setProducts(products);
  };
  const handleOnDelete = (record, index) => {
    const { child, parentUuid, uuid } = record;
    if (!child) {
      const p = products.filter((i) => {
        return i.uuid !== uuid;
      });
      setProducts(p);
      handleOnChange(p);
    } else {
      const p = products.map((i) => {
        if (i.uuid === parentUuid) {
          const { children } = i;
          const _children = (children || []).filter((i) => i.uuid !== uuid);
          return { ...i, children: _children };
        } else {
          return i;
        }
      });
      setProducts(p);
      handleOnChange(p);
    }
  };
  const handleOnDeleteAll = () => {
    setProducts([]);
    handleOnChange([]);
  };
  const handleOnEdit = () => {
    setVisible(true);
  };
  const handleOnOk = (products) => {
    const _p = products;
    setProducts(_p);
    handleOnChange(_p);
    handleOnCancel();
  };
  return (
    <div className={css.productTableContainer} id={id}>
      {visible && (
        <ProductSelection
          disabledProducts={
            // mockData
            disabledProducts
          }
          //uniqueSku
          canSelectChildren
          selectedProducts={products}
          onCancel={handleOnCancel}
          visible={visible}
          salesChannelUuid={salesChannelUuid}
          onOk={handleOnOk}
          disableEdit={disableEdit}
          withMultiCurrency={true}
          initialSearchProps={currency ? { currencyCode: currency } : {}}
        />
      )}
      <SizeFittingTable
        id={tableId || 'SalesChannelProductTable' + id}
        dataSource={processProduct}
        pagination={false}
        columns={col(handleOnDelete, disableEdit, { getI18n })}
        rowKey={'uuid'}
        scroll={{ x: 'max-content', y: 600 }}
        expandable={{
          //indentSize: 16,
          expandIcon: ({ expanded, onExpand, record }) => {
            if (record.children) {
              return expanded ? (
                <Icon
                  onClick={(e) => onExpand(record, e)}
                  className={css.expandIcon}
                  type='iconleft'
                  style={{ transform: 'rotate(270deg)' }}
                />
              ) : (
                <Icon
                  type='iconleft'
                  onClick={(e) => onExpand(record, e)}
                  className={css.expandIcon}
                  style={{ transform: 'rotate(180deg)' }}
                />
              );
            }
            return null;
          },
        }}
      />
      <div className={css.btnsContainer}>
        <Button
          className={css.addBtn}
          type='primary'
          onClick={handleOnEdit}
          disabled={disableEdit}>
          {getI18n('general.selectProduct')}
        </Button>
        {!isNoData && (
          <Button
            className={css.deleteBtn}
            onClick={handleOnDeleteAll}
            disabled={disableEdit}>
            {getI18n('general.deleteall')}
          </Button>
        )}
      </div>
    </div>
  );
};
const col = (onDelete, disableEdit, { getI18n }) => {
  return [
    {
      title: getI18n('general.productName'),
      dataIndex: 'productName',
      default: true,
      sorter: (a, b) => {
        const name1 = a.productName || '';
        const name2 = b.productName || '';
        const n1 = name1.toLowerCase();
        const n2 = name2.toLowerCase();
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
        return 0;
      },

      className: css.expandRow,
      key: 'productName',
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { thumbnailUrl, productName } = record;
        return (
          <div className={css.productNameContainer}>
            {thumbnailUrl && (
              <img
                style={{
                  marginRight: 12,
                }}
                width={40}
                height={40}
                key={thumbnailUrl}
                src={thumbnailUrl}
                alt={thumbnailUrl}
              />
            )}
            <NoWrapContainer>
              <GlobalTooltip title={productName || '-'}>
                <div className={css.text}>{productName || '-'}</div>
              </GlobalTooltip>
            </NoWrapContainer>
          </div>
        );
      },

      minWidth: 220,
    },
    {
      title: getI18n('general.sKU'),
      dataIndex: 'sku',
      default: true,
      sorter: (a, b) => {
        const name1 = a.sku || '';
        const name2 = b.sku || '';
        const n1 = name1.toLowerCase();
        const n2 = name2.toLowerCase();
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
        return 0;
      },

      key: 'sku',

      minWidth: 100,
    },
    {
      title: getI18n('general.remarks'),
      dataIndex: 'remarks',
      default: true,
      key: 'remarks',
      minWidth: 100,
    },
    {
      title: getI18n('general.tags'),
      dataIndex: 'tags',
      default: true,
      align: 'center',
      key: 'tags',
      minWidth: 150,
      tags: true,
      tagsGenerator: (
        characterLength,
        width,
        marginPaddingWidth,
        containPaddingWidth,
        tags,
        record,
      ) => {
        return (
          <TagGroup
            characterLength={characterLength}
            containerWidth={width}
            marginPaddingWidth={marginPaddingWidth}
            containPaddingWidth={containPaddingWidth}
            tags={tags}
          />
        );
      },
    },
    {
      title: getI18n('general.alias'),
      default: true,
      key: 'alias',
      minWidth: 72,
      childGenerate: (a, record) => {
        const { alias, child } = record;
        return <span>{child ? '' : alias ? 'Alias' : '-'}</span>;
      },
    },
    {
      title: getI18n('general.visibility'),
      default: true,
      key: 'Visibility',
      align: 'center',
      width: 80,
      childGenerate: (a, record) => {
        const { visible } = record;
        return (
          <div className={css.icon}>
            {visible ? (
              <EyeOutlined className={css.eye} />
            ) : (
              <Icon type={'iconinvisible'} />
            )}
          </div>
        );
      },
    },
    disableEdit
      ? {}
      : {
          titleGenerate: () =>
            getI18n(
              'general.advancedFilters.commonStoreProductsWithTable.actions',
            ),
          position: EnumTablePosition.mid,
          key: 'Actions',
          default: true,
          childGenerate: (url, record, index) => {
            return (
              <Actions
                onDelete={() => {
                  if (onDelete) {
                    onDelete(record, index);
                  }
                }}
              />
            );
          },
          width: 190,
        },
  ];
};
export default ProductTable;
